import ProfileDropdown from "./ProfileDropdown";
import { type User } from "~/context/AuthContext";

interface NavbarProps {
  user: User;
  handleLogout: () => Promise<void>;
}

export default function Navbar({ user, handleLogout }: NavbarProps) {
  return (
    <div className="px-4 py-2 flex justify-between">
      <img src="/logo-w-logotype.svg" alt="logo" className="w-36" />
      <ProfileDropdown user={user} handleLogout={handleLogout} />
    </div>
  );
}
